import type React from "react";

import { Stack, Typography } from "@mui/material";

import type { MedicalNoteAddendum } from "api/models/MedicalNoteAddendum";
import { useLocalizedDate } from "utils/date";

interface Props {
  medical_note_addenda?: MedicalNoteAddendum[];
}

export const AddendumList: React.FC<Props> = ({ medical_note_addenda }) => {
  const { format, parseISO } = useLocalizedDate();

  return (
    <Stack spacing={2} mb={3}>
      {medical_note_addenda?.map(addendum => {
        return (
          <Stack key={addendum.id} spacing={0.5}>
            <Typography
              variant="subtitle1"
              color="textSecondary"
              title={format(parseISO(addendum.created_at), "PP p")}
            >{`${format(parseISO(addendum.created_at), "d MMMM, yyyy")} - ${
              addendum.health_care_professional_name
            }`}</Typography>
            <Typography>{addendum.body}</Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};
